import React from 'react';
import {Box, Stack, styled} from '@mui/material';
import {Headline} from '@lightricks/react-design-system';
import Guide from '@contentlab/components/feature-editor/components/file-upload/Guide';
import LipSyncToggle from '@contentlab/components/lip-sync-toggle';
import {DraftRephrasingProject} from '@contentlab/stores/contentLabStore';
import translate from '@/utils/translate';

const Container = styled(Box)(() => ({
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0 24px 24px',
  gap: '28px',
}));

function RephraseContent({
  children,
  draftRephrasingProject,
  lipSyncEnabledChanged,
  onLearnModeClick,
}: {
  children?: React.ReactNode;
  draftRephrasingProject: DraftRephrasingProject;
  lipSyncEnabledChanged: (enabled: boolean) => void;
  onLearnModeClick: () => void;
}) {
  return (
    <Container>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        paddingInlineEnd="24px"
      >
        <Headline size="md">
          {translate('Select a paragraph to edit text')}
        </Headline>
        <LipSyncToggle
          title={translate(
            'Sync translated audio with mouth movements. Turn off for voiceover‒only videos to save processing time.'
          )}
          onChange={(enabled: boolean) => {
            lipSyncEnabledChanged(enabled);
          }}
          enabled={draftRephrasingProject.enableLipSync}
        />
      </Stack>
      <Guide
        guideDescription={translate(
          'Use clear speech with natural pauses and minimal background noise.'
        )}
        sx={{
          alignItems: 'flex-start',
          textAlign: 'initial',
          marginInlineEnd: '24px',
        }}
        onLearnMoreClick={onLearnModeClick}
      />
      {children}
    </Container>
  );
}

export default RephraseContent;
